import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { AdminProfileService } from 'modules/admin/shared/services/admin-profile.service';
import { CommonDataService } from 'modules/group/shared/commonData.service';
// import { OnecartAppInitializerService } from 'modules/onecart/services/onecart-app-initializer.service';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { finalize, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

declare var $: any;

const RemoveLoaderForUrls = ['/login/', '/validatetoken/', '/uploadFile', '/wbe-kiosk-service/cico/tenants/'];

let urlStack = [];
@Injectable()
export class AppInterceptor implements HttpInterceptor {
  public isAzureB2CAuthenticationEnabled: boolean = false;
  constructor(
    // public onecartAppInitService: OnecartAppInitializerService,
    public legacyBookInitService: LegacyBookInitService,
    public commonDataService: CommonDataService,
    public adminProfileService: AdminProfileService
  ) {
    if (environment.isAzureB2CAuthenticationEnabled === 'true') {
      this.isAzureB2CAuthenticationEnabled = true;
    }
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let pathData = location.pathname.split('/');
    let appName = pathData[1];
    switch (appName) {
      case 'admin':
        if (sessionStorage.getItem('token')) {
          console.log('req', req);
          req = req.clone({
            setHeaders: {
              'X-Token': sessionStorage.getItem('token'),
            },
          });
          let headers = {
            headers: {
              'X-Token': sessionStorage.getItem('token'),
            },
          };
          if (req.url == 'https://aks-wbe-dev.hospitalityrevolution.com/node/nodeapi') {
            if (req.body.url.includes(this.adminProfileService.seatEndPoints.getBookingDetailsWithRateSummary)) {
              let headers = {
                headers: {
                  'X-Token': sessionStorage.getItem('token'),
                  SEAT_JWT_TOKEN: `Bearer ${this.adminProfileService.accessToken}`,
                },
              };
              req.body.header = headers;
            } else {
              req.body.header = headers;
            }
          }
        }
        if (req.method === 'PUT' || req.method === 'POST') {
          const userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
          // no need to pass lastModifiedUser in analyticsData url
          const isAnalyticsUrl = req?.body?.url?.includes('analyticsData') || req?.url?.includes('analyticsData');
          if (userDetails && userDetails.username && req.body && !isAnalyticsUrl) {
            if (req.url != 'https://aks-wbe-dev.hospitalityrevolution.com/node/nodeapi') {
              req.body.lastModifiedUser = userDetails.username;
            } else {
              if (req.body.data) {
                req.body.data.lastModifiedUser = userDetails.username;
              }
              if (req.body.data && req.body.data.spendPackage) {
                delete req.body.data.lastModifiedUser;
              }
            }
          }
        }

        if (!this.isExcluded(req.url)) {
          urlStack.length === 0 && this.siteLoading('Loading...');
          urlStack.push(req.url);
        }
        return next.handle(req).pipe(
          finalize(() => {
            urlStack = urlStack.filter((url) => url !== req.url);
            urlStack.length === 0 && this.siteLoading('');
          })
        );
      case 'wbe':
      case 'cico':
      case 'golf':
      case 'spa':
        let url = req.url;
        if (req.url == 'https://aks-wbe-dev.hospitalityrevolution.com/node/nodeapi') {
          url = req.body.url;
        }
        const currentAPIDomain = this.extractDomain(url);
        const browserUrl = window.location.protocol + '//' + document.location.hostname;
        const backendAPIDomain = !environment.proxy
          ? this.extractDomain(browserUrl)
          : appName === 'cico'
          ? this.extractDomain(environment.expressBackendApiUrl)
          : this.extractDomain(environment.backendApiUrl);
        const token = this.commonDataService?.token;
        if (currentAPIDomain === backendAPIDomain && token && this.shouldPassHeaderToURL(url)) {
          if (req.url == 'https://aks-wbe-dev.hospitalityrevolution.com/node/nodeapi') {
            if (this.isAzureB2CAuthenticationEnabled) {
              if (req.body.header?.headers) {
                req.body.header.headers['Authorization'] = `Bearer ${token}`;
              } else {
                const headers = {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                };
                req.body.header = { ...req.body.header, ...headers };
              }
            } else {
              if (req.body.header?.headers) {
                req.body.header.headers['Api-Key-Token'] = `${token}`;
              } else {
                const headers = {
                  headers: {
                    'Api-Key-Token': `${token}`,
                  },
                };
                req.body.header = { ...req.body.header, ...headers };
              }
            }
          } else {
            if (this.isAzureB2CAuthenticationEnabled) {
              req = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`),
              });
            } else {
              req = req.clone({
                headers: req.headers.set('Api-Key-Token', `${token}`),
              });
            }
          }
        }
        return next.handle(req).pipe(this.modifyErrorMessage(this.legacyBookInitService));
      case 'onecart':
      // return next.handle(req).pipe(this.modifyErrorMessage(this.onecartAppInitService));
      default:
        return next.handle(req);
    }
  }

  private extractDomain(url: string): string | null {
    let domain;
    try {
      const parsedUrl = new URL(url);
      domain = parsedUrl.hostname;
    } catch {
      domain = null;
    }
    return domain;
  }

  private shouldPassHeaderToURL(url: string): boolean {
    return (
      !url.includes('wbe-admin-service/generatetoken/v2/tenants') &&
      !url.includes('wbe-admin-service/generateAzureBlobStorageSAS') &&
      !url.includes('wbe-admin-service/generatetoken/tenants')
    );
  }

  /**
   * Modifies response.ErrorMessage as per Adminportal Configuration (if available).
   * @param appInit - Corresponding App Initializer
   * @returns MAP function that modifies response.ErrorMessage
   */
  modifyErrorMessage(appInit: LegacyBookInitService) {
    return map((e: HttpEvent<any>) => {
      if (e instanceof HttpResponse && this.checkResponseWithStatusCode(e)) {
        let body = e.body;
        body.errorMessage = appInit.getErrorMessage(body?.statusCode) || body?.errorMessage;
        return e.clone({ body });
      }
      return e;
    });
  }

  /**
   * Check whether the Response is valid and have "StatusCode".
   * @param appInit - Corresponding App Initializer
   * @returns true for valid response with "StatusCode"
   */
  checkResponseWithStatusCode(e: HttpEvent<any>): boolean {
    return e instanceof HttpResponse && e.status == 200 && e.body && !(e.body.Success || e.body.success) && e.body.statusCode;
  }

  isExcluded(url: string) {
    let exclude = false;
    RemoveLoaderForUrls.forEach((e) => {
      if (url.includes(e)) exclude = true;
    });
    return exclude;
  }

  siteLoading(text: string) {
    if (text) {
      $('#preloaderAdmin').css({ display: 'block' });
      document.querySelector('html').classList.add('scroll-block');
    } else {
      $('#preloaderAdmin').css('display', 'none');
      document.querySelector('html').classList.remove('scroll-block');
    }
    $('#preloaderAdminText').html(text);
  }
}
